// extracted by mini-css-extract-plugin
export default {"category-container":"FilterSelectList_category-container__CLtxl"};